import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { ErpSyncRegistryPage } from '@pages/erp-sync-registry';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/mapping')({
  validateSearch: z.object({
    contract: z.string().optional(),
  }),
  component: ErpSyncMappingRoute,
});

function ErpSyncMappingRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ErpSyncRegistryPage
      mode="mapping"
      initialContractKey={search.contract}
      onBackToDataTypes={() => {
        void navigate({ to: '/$locale/erp-sync/registry', params: { locale } });
      }}
    />
  );
}
